import { Button, Input, WithActions, PlusSmall, Minus } from "components";
import { t } from "i18next";

interface FormData {
  parking_name_mk: string;
  parking_name_al: string;
  parking_name_en: string;
  longitude: string;
  latitude: string;
  municipality_id: number;
  area_type: string;
  total_parking_slots: number;
  payment_options: number[];
  amenities: number[];
}

interface TypeSlotsStepProps {
  form: FormData;
  handleChange: (key: keyof FormData, value: string | number | number[]) => void;
  errorMessage: string | null;
  onClose: () => void;
  prevStep: () => void;
  nextStep: () => void;
  isLoading: boolean;
  getParkingNameByLanguage: () => string;
}

export const TypeSlotsStep: React.FC<TypeSlotsStepProps> = ({
  form,
  handleChange,
  errorMessage,
  onClose,
  prevStep,
  nextStep,
  isLoading,
  getParkingNameByLanguage,
}) => {
  const handleToggle = (type: string) => {
    handleChange("area_type", form.area_type === type ? "" : type);
  };

  return (
    <div>
      <h3 className="text-xs font-light uppercase text-primary">
        Configure Parking ({getParkingNameByLanguage() || "PARKING NAME"})
      </h3>

      <div className="mt-2 space-y-4">
        <h4 className="font-semibold">{t("parkingManagement.parkingType")}*</h4>
        <div className="flex gap-4">
          {["Open", "Closed"].map((type) => {
            const selected = form.area_type === type;
            const baseClasses = "flex items-center border rounded min-w-[120px] h-[48px]";
            const selectedClasses = selected ? "border-green-600" : "border-[#1C67AD] text-[#1C67AD]";
            return (
              <button key={type} onClick={() => handleToggle(type)} className={`${baseClasses} ${selectedClasses}`}>
                <div className="flex-1 px-4 text-left font-semibold">{type}</div>
                <div
                  className={`flex h-full w-[40px] items-center justify-center ${
                    selected ? "bg-green-600" : "bg-primary"
                  }`}
                >
                  {selected ? <Minus className="text-white" /> : <PlusSmall className="text-white" />}
                </div>
              </button>
            );
          })}
        </div>

        <h4 className="font-semibold">{t("parkingManagement.totalParkingSlots")}*</h4>
        <div className="flex items-center">
          <Input
            value={form.total_parking_slots.toString()}
            onChange={(e) => handleChange("total_parking_slots", Number(e.target.value))}
            placeholder={t("parkingManagement.totalParkingSlots")}
            className="border-[#1C67AD] font-bold text-[#1C67AD] placeholder-[#1C67AD]"
            type="number"
            variant="modal"
          />
        </div>
      </div>

      {errorMessage && <p className="mt-1 text-xs text-red-500">{errorMessage}</p>}

      <WithActions
        closeButton={t("common.cancel")}
        setOpen={onClose}
        additionalButtons={
          <>
            <Button onClick={prevStep}>Back</Button>
            <Button onClick={nextStep} disabled={isLoading}>
              {t("common.continue")}
            </Button>
          </>
        }
      />
    </div>
  );
};
